import { isReportableResourceEntry } from './isReportableResourceEntry';
import { getResourcePerformanceEvent } from './resourcePerformanceEvent';
import { GetEventsForPerformanceEntries } from './types';

const getEventsForResourceEntries: GetEventsForPerformanceEntries = (entries) =>
  entries.filter(isReportableResourceEntry).map(getResourcePerformanceEvent);

export default getEventsForResourceEntries;
